"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TmsDestinationSchema = void 0;
const zod_1 = require("zod");
exports.TmsDestinationSchema = zod_1.z.object({
    displayName: zod_1.z.string().min(1),
    lat: zod_1.z.number(),
    lon: zod_1.z.number(),
    estimatedArrivalAt: zod_1.z.string().datetime().nullable(),
    dataTimestamp: zod_1.z.string().datetime(),
});
//# sourceMappingURL=destination.js.map